import { StyledLoadingMessage } from './LoadingMessage.styles';
import { LoadingSpinner } from '../LoadingSpinner/LoadingSpinner';

export const LoadingMessage = ({ message }) => (
  <StyledLoadingMessage>
    <LoadingSpinner size={24} />
    <span className='loading-text'>{message}</span>
  </StyledLoadingMessage>
);
